import NavigationBar from "../components/NavigationBar";
import Footer from "../components/Footer";
import HomePage from "../pages/HomePage";
import {Route, Routes} from "react-router-dom";
import ResultsPage from "../pages/ResultsPage";

const DefaultLayouts = () => {
    return (
        <div>
            <NavigationBar/>
            <Routes>
                <Route path="/*" Component={HomePage}></Route>
                <Route path="/results" Component={ResultsPage}></Route>
            </Routes>
            <Footer />
        </div>
    )
}

export default DefaultLayouts
